





















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MenuPopupBar extends Vue {
  @Prop() private title!: string;

  @Prop({ required: true }) private scrollTarget!: string;
}
